var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
// Styling
import styles from './Surface.css.js';
export const surfaceTypeOptions = [
    'none',
    'thin',
    'thick',
    'elevated',
    'elevated-not-clickable-centered',
    'elevated-not-clickable-centered-with-backdrop',
    'elevated-not-clickable-above',
    'elevated-not-clickable-under',
    'floating',
];
// Data
import config from './Surface.config.json';
/**
 * @element zz-surface
 */
export class Surface extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'thin';
        this.clickable = false;
        this.theme = config.defaultThemeName;
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<slot></slot>`;
    }
    firstUpdated() {
        const { clickable } = this;
        if (clickable) {
            this.setAttribute('role', 'button');
        }
    }
}
__decorate([
    property({ type: String, reflect: true })
], Surface.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], Surface.prototype, "clickable", void 0);
__decorate([
    property({ reflect: true })
], Surface.prototype, "theme", void 0);
